import { useMediaQuery } from '@material-ui/core';
import { generatePath } from 'react-router-dom';

import { channelAgentNameFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/channelAgentNameFieldColumn';
import { createdAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/createdAtFieldColumn';
import { toDealDetailFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/toDealDetailFieldColumn';
import { updatedAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/updatedAtFieldColumn';
import { customerFieldColumn } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/customerFieldColumn';
import { principalFieldColumn } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/principalFieldColumn';
import { singlePaymentTypeFieldColumn } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/singlePaymentTypeFieldColumn';
import { statusFieldColumn } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/statusFieldColumn';
import { statusWithPrincipalAmountMobile } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/statusWithPrincipalAmountMobile';
import { updatedAtWithBorrowerNameFieldColumnMobile } from '@/components/modules/SinglePaymentListByProduct/utils/SinglePaymentDataGridFields/components/updatedAtWithBorrowerNameFieldColumnMobile';
import { DETAILS_PATH_BY_PRODUCT } from '@/config/config';
import { SinglePaymentApplicationType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export function SinglePaymentDataGridFields({ applicationType }: { applicationType: SinglePaymentApplicationType }) {
  const { breakpoints } = useCustomTheme();

  const isDownMd = useMediaQuery(breakpoints.down('md'));
  const targetPath = DETAILS_PATH_BY_PRODUCT[applicationType];

  const linkTo = (id) => generatePath(targetPath, { paymentMethodId: id });

  const singlePaymentFields = {
    desktop: [
      singlePaymentTypeFieldColumn({ applicationType, flex: 0.15 }),
      customerFieldColumn({ flex: 0.38 }),
      channelAgentNameFieldColumn({ flex: 0.34 }),
      principalFieldColumn({ flex: 0.26 }),
      createdAtFieldColumn({ flex: 0.38 }),
      updatedAtFieldColumn({ flex: 0.38 }),
      statusFieldColumn({ flex: 0.33 }),
      toDealDetailFieldColumn({ linkTo, flex: 0.15 }),
    ],
    mobile: [updatedAtWithBorrowerNameFieldColumnMobile({ flex: 0.6 }), statusWithPrincipalAmountMobile({ flex: 0.5 })],
  };

  return isDownMd ? singlePaymentFields.mobile : singlePaymentFields.desktop;
}
